import { RootInitialState } from 'core/common/store/rootReducer';

export const getDetectScanProcessingStatus = (state: RootInitialState) => {
  return state.scan.detectProcessingStatus;
};

export const getUploadScanProcessingStatus = (state: RootInitialState) => {
  return state.scan.uploadProcessingStatus;
};

export const getScan = (state: RootInitialState) => {
  return state.scan.data;
};
